module.exports = __webpack_public_path__ + "static/media/follow-up-icon.93111b46.png";